import axios, { AxiosResponse } from 'axios';
import { configApis, loginApis } from '../../../common/apis';
import { SamlRequestVO } from '../typing';

/**
 * 获取用学习培训连接配置
 * @returns Promise 对象
 */
 export const fetchLearnLinkConfig = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(configApis.learnLinkConfig).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      },
    );
  })
};

/**
 * 获取用户访问业绩连接配置
 * @returns Promise 对象
 */
export const fetchVisitedLinkConfig = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(configApis.visitedLinkConfig).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      },
    );
  })
};

/**
 * 获取 saml
 * @param samlRequestVO 获取 saml 的 request payload 对象
 * @returns Promise 对象
 */
export const fetchSaml = (samlRequestVO: SamlRequestVO): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(configApis.fetchSaml, samlRequestVO).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      },
    );
  })
};

/**
 * 用户退出
 * @returns Promise 对象
 */
export const logout = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(loginApis.logoutPysix).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      },
    );
  })
};

/**
 * 调用后端的/oauth2/login 方法，参数是pageName
 * @param pageName 页面名称
 * @returns Promise 对象
 */
export const fetchPageUrl = (pageName: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        // 假设loginApis.oauth2Login是一个已定义好的API路径
        // 如果不是，请替换为实际的API路径
        axios.get(`${configApis.fetchPageUrl}?pageName=${pageName}`).then(
            (res: AxiosResponse<any>) => {
                resolve(res.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
};

